<template>
  <div>
  
    <label class="control-label"
      >{{ title }}
      <span v-show="tempUpload" @click="clear" class="bold">
        - Отмена</span
      ></label
    >
    <div class="media-input">
    
      <audio :src="value" controls v-if="value">

      </audio>

      <div class="media-input-choose">
        <h6 class="link">Загрузить Аудио</h6>
        <input
          ref="fileupload"
          type="file"
          :name="`${name}_audio`"
          @change="handleFileUpload"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    oldData: null,
    noImage: require("@/assets/img/no-photo-available.png"),
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: {
    title: {
      default: "",
    },
    value: {
      default: null,
    },
    name: {
      default: null,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", this.oldData);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (file.size > 51000000) {
          this.$notify({
            title: "Ошибка",
            message: "Файл более 50 мб. весит",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
          return false;
        }
        //this.$emit("input", file);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.$emit("input", reader.result);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.media-input {
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  width: 100%;
  & > audio {
    width:100%;
  }
  & > .media-input-choose {
    text-align: center;
    position: relative;
    overflow: hidden;
    & > input {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 999;
      top:0;
      left: 0;
      right:0;
      bottom: 0;
      opacity: 0;
    }
  }
  // justify-content: center;
}
</style>